import React from 'react';
import { isSmartPhone } from '../../utilities/helper';
import TransactionHistoryTabBarMWeb from './index_mWeb';
import TransactionHistoryTabBarWeb from './index_web';
interface Props {
  onChangeTab?: any;
  activeTab?: number;
  routes?: any;
}
const TransactionHistoryTabBar = ({ onChangeTab, activeTab, routes = [] }: Props) => {
  return (
    <>
      {isSmartPhone ? (
        <TransactionHistoryTabBarMWeb
          onChangeTab={onChangeTab}
          activeTab={activeTab}
          routes={routes}
        />
      ) : (
        <TransactionHistoryTabBarWeb
          onChangeTab={onChangeTab}
          activeTab={activeTab}
          routes={routes}
        />
      )}
    </>
  );
};
export default React.memo(TransactionHistoryTabBar);
